import * as React from "react";
export class HeadingTitle extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-ev-list__heading-title", "data-uat": "div-ev-list-heading-title" },
            React.createElement("span", { className: "rj-ev-list__heading-title__content rj-ev-list__heading-title__name", "data-uat": "span-ev-list-heading-title-name" },
                this.props.name,
                React.createElement("span", { className: "rj-ev-list__heading-title__content rj-ev-list__heading-title__count", "data-uat": "span-ev-list-heading-title-count" }, this.props.eventsCount))));
    }
}
//# sourceMappingURL=HeadingTitle.js.map